<template>
  <div>
    <H5 v-if="isMobile" :qrcodeUrl="qrcodeUrl" />
    <PC v-else :qrcodeUrl="qrcodeUrl" :channelList="channelList" />
  </div>
</template>

<script lang="ts" setup>
import PC from './pc.vue';
import H5 from './h5.vue';
import { reqGetChannel, type IChannel } from '@/api';

const { isMobile } = useDevice();

const route = useRoute();
const source = computed(() => route.query?.pcode || '0');
const channelList = ref<IChannel[]>([]);

setPageLayout(isMobile ? 'h5' : 'exposed');

const qrcodeUrl = ref<string | undefined>('');

const getChannel = () => {
  reqGetChannel().then(res => {
    const data = res.data?.find(v => v.code === source.value);
    channelList.value = res.data || [];
    qrcodeUrl.value = isMobile ? data?.h5_link : data?.pc_link;
  });
};

getChannel();
</script>
